// extracted by mini-css-extract-plugin
export default {"btn":"DamrV","btn--prev":"US4SS","btn--next":"BlEye"};